/**
 * EnvironmentalRerunPanel — thin wrapper around FeasibilityRerunPanel that
 * passes the environmental gap categorizer (NEPA / Species / Air / Water /
 * Cultural / Tribal). Workflow Prompt 6.
 *
 * Rerun Reimagined RR4 closes the previously-deferred per-type
 * config-form override: the merged Configuration step renders
 * `ReportTypePreferencesFields reportType="environmental"` so this
 * wrapper inherits NEPA scope / species window / wetlands prefs for
 * free — no per-wrapper preference form to maintain.
 */
import React from 'react';
import { FeasibilityRerunPanel, type RerunPanelProps, type DataGapItem } from './FeasibilityRerunPanel';
import { getGapCategoriesForType } from '../../../lib/rerunGapCategories';

export function EnvironmentalRerunPanel(props: RerunPanelProps) {
  return (
    <FeasibilityRerunPanel
      {...props}
      gapCategorizer={(gaps: DataGapItem[]) => getGapCategoriesForType('environmental', gaps)}
    />
  );
}
